export class RequestMapper {
	static formatRequestList(list) {
		const mapped = list.map((item) => ({
			id: item.id,
			image: item.businessCoverImagePath,
			score: item.score ?? item.businessScore ?? '',
			reviewCount: item.reviewCount ?? item.businessReviewCount,
			address: item.businessAddress,
			title: item.businessName,
			openShop: false,
			shopId: item.businessId,
			startDate: item.totalStartDate,
			endDate: item.totalEndDate,
			totalStartDate: item.totalStartDate,
			totalEndDate: item.totalEndDate,
			reserveItems: item.reserveItems ?? [],
			totalPrice: item.totalPrice,
			totalDurationMinutes: item.totalDurationMinutes,
			paymentType: item.paymentType,
			trackingCode: item.trackingCode ?? item.code ?? item.referenceNumber,
			state: item.state,
		}));
		return mapped;
	}
}
